import requests from "./httpService";

const TopSellingServices = {
  getAllSlider: async (body) => {
    return requests.get(`/slider/`);
  },

  addSlider: async (body) => {
   
    return requests.post(`/slider/add`, body);
  },
  getSliderById: async (id) => {

    return requests.get(`/slider/${id}`);
  },

  updateSlider: async (id, body) => {
    return requests.put(`/slider/update/${id}`, body);
  },

  deleteSlider: async (id) => {
    return requests.delete(`/slider/delete/${id}`);
  },
};

export default TopSellingServices;
